import { useSelector } from "react-redux";

import "./TabDetails.css";

import DeleteIcon from "../../static/image/deleteIcon.svg";
import CustomInput from "../../components/customInput/CustomInput";

function Package({
  templateList,
  language,
  onInputChange,
  onShowUploadFile,
  onShowDeleteFile,
  packageData
}) {
  const { data, error } = useSelector((state) => state.package);

  const imageUrl = packageData?.imageUrl || data?.imageUrl;

  return (
    <>
      <div className="tab-package-container">
        {templateList.map((template, index) => {
          if (template.type === "text") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <CustomInput
                  type="text"
                  value={data?.[template.id] || ""}
                  onChange={(e) =>
                    onInputChange(template.id, e.target.value, language)
                  }
                  placeholder={template.placeholder[language]}
                  customStyle={{ width: "73%" }}
                  error={error?.[template.id]}
                />
              </div>
            );
          }

          if (template.type === "textarea") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <textarea
                  value={data?.[template.id] || ""}
                  onChange={(e) =>
                    onInputChange(template.id, e.target.value, language)
                  }
                  placeholder={template.placeholder[language]}
                ></textarea>
              </div>
            );
          }

          if (template.type === "file") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <div style={{ width: "73%" }}>
                  <div className="input-with-button">
                    <input
                      type="text"
                      placeholder={template.placeholder[language]}
                      value={data?.[template.id] || ""}
                      onChange={(e) => onInputChange(template.id, e.target.value)}
                      disabled
                    />
                    {!data?.[template.id] && (
                      <button
                        className="upload-btn"
                        onClick={() => onShowUploadFile(template.id)}
                      >
                        Upload
                      </button>
                    )}
                    {data?.[template.id] && (
                      <button
                        className="icon-btn"
                        onClick={() => onShowDeleteFile(template.id)}
                      >
                        <img
                          src={DeleteIcon}
                          alt="Delete"
                          className="action-icon"
                        />
                      </button>
                    )}
                  </div>

                  {template.id === "titleImageFileId" && imageUrl && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={imageUrl}
                        alt="Title Image"
                        style={{
                          maxWidth: "400px",
                          maxHeight: "400px",
                          border: "1px solid #ddd",
                          borderRadius: "4px"
                        }}
                        onError={(e) => {
                          console.error('Image failed to load:', imageUrl);
                          e.target.style.display = 'none';
                        }}
                        onLoad={() => console.log('Image loaded successfully')}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          }

          return <></>;
        })}
      </div>
    </>
  );
}

export default Package;
